// servizi/liberatoria.ts — liberatoria per tester e riprese: testo attivo, firma, firme mie e PDF.
import { richiesta, scaricaFile } from "./api.ts";

export interface TestoLiberatoria {
  versione: number;
  titolo: string;
  testo: string;
  lingua: string;
  impronta: string;
  etaMinima: number;
  /** v029: le lingue in cui c'è una versione attiva (per la scelta nella pagina) */
  lingue?: { lingua: string; versione: number }[];
}
export interface FirmaMia {
  id: number;
  versione: number;
  titolo: string;
  /** v029 */
  lingua?: string;
  nome_firmatario: string;
  firmata_il: string;
  /** v021: data del ritiro (null = valida) */
  ritirata_il?: string | null;
}

/** v029: la versione nella lingua chiesta (se c'è; altrimenti quella del browser, poi l'inglese). */
export const leggiLiberatoria = (lingua?: string) =>
  richiesta<TestoLiberatoria>(`/api/v1/liberatoria${lingua ? `?lingua=${encodeURIComponent(lingua)}` : ""}`);

export function firmaLiberatoria(t: TestoLiberatoria, nome: string): Promise<{ id: number; firmata_il: string }> {
  return richiesta("/api/v1/liberatoria/firma", { metodo: "POST", corpo: { versione: t.versione, impronta: t.impronta, nome, accetto: true } });
}

export const liberatorieMie = async () => (await richiesta<{ voci: FirmaMia[] }>("/api/v1/io/liberatorie")).voci;

/** v021 (scelta 17): «Ritira la liberatoria». */
export const ritiraLiberatoria = (id: number) => richiesta<{ id: number; ritirataIl: string }>(`/api/v1/io/liberatorie/${id}/ritira`, { metodo: "POST" });

export const scaricaPdfLiberatoria = (id: number) => scaricaFile(`/api/v1/io/liberatorie/${id}/pdf`, `laughdown-liberatoria-${id}.pdf`);
